import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {SAMPLING_POINTS_QUERY_KEY} from '../../api/queries/getSamplingPoints'
import {SamplingPoint} from '../../types'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export function useSamplingPointsQuery(): UseQueryResult<SamplingPoint[]> {
  const plantCode = useUrlParam('plantCode')
  const {t} = useTranslation()

  return useSettingsQuery(SAMPLING_POINTS_QUERY_KEY, [plantCode], {
    meta: {
      errorMessage: t('samplingPointsSettings.queries.fetchSamplingPointsError')
    }
  })
}
